import React, { Fragment } from 'react';
import moment from 'moment';
import nl2br from 'react-nl2br';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { appColours } from '../../helpers';

const colours = appColours();
const styles = () => ({
  card: {
    marginBottom: 16,
    padding: 16,
    position: 'relative',
  },
  scoreImage: {
    width: 32,
    height: 32,
  },
  noteWrapper: {
    padding: 16,
    marginTop: 16,
    border: '1px solid #eee',
  },
  trackerWrapper: {
    marginTop: 16,
  },
  infoColumn: {
    padding: '8px 0 0 16px',
    color: '#46606d',
    fontSize: 14,
  },
  actionButtonsWrapper: {
    marginTop: -8,
    textAlign: 'right',
  },
});

class MentalHealthEntryCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      t,
      mentalHealthEntry,
      onDeleteClick,
      onEditClick,
    } = this.props;

    return (
      <div className="mental-health-entry-card">
        <Paper
          elevation={1}
          key={mentalHealthEntry.id}
          className={classes.card}
        >
          <Grid
            container
            justify="space-between"
            className={classes.padding}
          >
            <Grid item>
              <Grid container>
                <Grid item>
                  <img
                    className={classes.scoreImage}
                    src={`${rootUrl}/img/tracking/${mentalHealthEntry.score}.png`}
                  />
                </Grid>
                <Grid
                  item
                  className={classes.infoColumn}
                >
                  <span>
                    {mentalHealthEntry.teacher && (
                      <span>
                        <b>
                          <span>{t('Teacher')}</span>
                          <span>: </span>
                        </b>
                        <span>{mentalHealthEntry.teacher.title}. </span>
                        <span>{mentalHealthEntry.teacher.first_name} </span>
                        <span>{mentalHealthEntry.teacher.last_name}</span>
                      </span>
                    )}
                    {mentalHealthEntry.parent && (
                      <span>
                        <b>
                          <span>{t('Parent/carer')}</span>
                          <span>: </span>
                        </b>
                        {mentalHealthEntry.parent.name}
                      </span>
                    )}
                    {mentalHealthEntry.by_pupil && (
                      <span>
                        <b>
                          <span>{t('Pupil')}</span>
                          <span>: </span>
                        </b>
                        {mentalHealthEntry.by_pupil.first_name}
                        <span> </span>
                        {mentalHealthEntry.by_pupil.last_name}
                      </span>
                    )}
                  </span>
                  <span> | </span>
                  <span>{moment(mentalHealthEntry.timestamp).format('HH:mm')}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              {(mentalHealthEntry.can_edit) && (
                <div className={classes.actionButtonsWrapper}>
                    <IconButton
                      aria-label={t('Edit')}
                      onClick={onEditClick.bind(this, mentalHealthEntry)}
                      className="mental-health-entry-card-edit-button"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      aria-label={t('Delete')}
                      onClick={onDeleteClick.bind(this, mentalHealthEntry)}
                      className="mental-health-entry-card-delete-button"
                    >
                      <DeleteIcon />
                    </IconButton>
                </div>
              )}
            </Grid>
          </Grid>
          {mentalHealthEntry.note && (
            <div className={classes.noteWrapper}>
              {nl2br(mentalHealthEntry.note)}
            </div>
          )}
          {mentalHealthEntry.mental_health_tracker && (
            <div className={classes.trackerWrapper}>
              <b>
                <span>{t('Tracker')}</span>
                <span>: </span>
              </b>
              {mentalHealthEntry.mental_health_tracker.name}
            </div>
          )}
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(MentalHealthEntryCard)));
